import React from "react";
import TopRepsAnalytics from "./representativeLeadsAnalytics";
import LeadStatusSummary from "./leadStatusSummary";
import TopCountriesAnalytics from "./TopCountriesAnalytics";
import TopPointsAnalytics from "./TopPointsAnalytics";
import PointsByReasonChart from "./PointsByReasonChart";
import CountryRepByNationality from "./CountryRepByNationality";

const AnalyticsDashboard = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 py-6 space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Representative Analytics Dashboard</h1>

      <LeadStatusSummary/>
      <TopRepsAnalytics/>
      <CountryRepByNationality/>
      <TopCountriesAnalytics/>
      <TopPointsAnalytics/>
      <PointsByReasonChart/>

    </div>
  );
};

export default AnalyticsDashboard;
